<template>
    <div class="mt-2" ref="loader">
        <b-container class="container-lg">
            <b-row class="pb-2">
                <b-col class="text-start">
                    <h5><i class="fa-solid fa-chevron-left" @click="goBack"></i> <i class="fa-solid fa-server"></i> {{ $t('Hostgroups') }}</h5>
                </b-col>
                <b-col class="text-end">
                    <button type="button" class="btn btn-light btn-sm" @click="refreshData">
                        <i class="fa-solid fa-arrows-rotate"
                           :class="{'fa-spin': loading}"></i>
                    </button>
                </b-col>
            </b-row>
            <b-list-group>
                <b-list-group-item>
                    <div class="row">
                        <div class="col">
                            <b-button v-b-toggle.filter class="m-0 w-100" variant="primary">
                                <i class="fa-solid fa-filter"></i>
                                {{ $t('Filter') }}
                            </b-button>
                        </div>
                    </div>
                    <b-collapse id="filter">

                        <div class="d-flex w-100 mt-2">
                            <b-form-input v-model="name" :placeholder="$t('name')"></b-form-input>
                        </div>
                        <div class="d-flex w-100 mt-2">
                            <b-form-input v-model="description" :placeholder="$t('description')"></b-form-input>
                        </div>
                        <div class="mt-2">
                            <b-button
                                class="w-100"
                                variant="outline-danger"
                                @click="allFilter">{{ $t('filter.reset-filter') }}
                            </b-button>
                        </div>
                    </b-collapse>
                </b-list-group-item>
            </b-list-group>
            <b-list-group
                v-for="hostgroup in hostgroups"
                v-bind:key="hostgroup.id"
                class="mt-2">
                <div class="flex-column align-items-start">
                    <div class="list-group-item flex-column align-items-start list-group-item-action ps-0">
                        <div class="d-flex flex-row">
                            <div class="min-width-0">
                                <div class="py-1 px-2">
                                    <div class="col-12 text-truncate h5">
                                        <router-link
                                            class="link-underline link-underline-opacity-0"
                                            :to="{name: 'hostgroupsDetails', params: {id: hostgroup.id}}">
                                            {{ hostgroup.container.name }}
                                        </router-link>
                                    </div>
                                    <div class="col-12 text-truncate">
                                        <small>
                                            {{ hostgroup.description }}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-list-group>
            <b-list-group class="mt-3" ref="noMass">
                <div v-if="hostgroups.length > 0">
                    <div class="d-flex w-100 justify-content-between">
                        <small>{{ $t('page') }} {{ paging.page }}</small>
                        <small>{{ $t('pagesize') }} {{ paging.limit }}</small>
                    </div>
                    <div class="d-flex w-100 justify-content-center mt-4">

                        <vue-awesome-paginate
                            :total-items="paging.count"
                            :items-per-page="25"
                            :max-pages-shown="5"
                            v-model="paging.page"
                            @click="getIndex"
                        />
                    </div>
                </div>
                <b-list-group-item v-if="hostgroups.length === 0">
                    <h5 class="mb-1">{{ $t('noitems') }}</h5>
                </b-list-group-item>
            </b-list-group>
        </b-container>
    </div>

</template>
<script>
import {debounce} from "../../helpers";
import {useToast} from "vue-toastification";
import {VueAwesomePaginate} from "vue-awesome-paginate";

export default {
    name: "HostgroupsIndex",
    components: {VueAwesomePaginate},
    data(){
        return {
            loading: true,
            requestStatus: false,
            listFilter: {
                filter: {
                    id: [],
                    uuid: [],
                    name: '',
                    description: "",
                }
            },
            hostgroups: [],
            paging: {
                page: 1,
                pageCount: 1,
            },
            name: '',
            description: ''
        }
    },
    mounted(){
        this.getIndex();
    },
    methods: {
        getIndex: function(page = 1){
            let loader = this.$loading.show();
            this.loading = true;
            axios.post('/hostgroups/index.json',
                {
                    filter: this.listFilter,
                    page: page
                },
                {}
            )
                .then(response => {
                    this.requestStatus = true;
                    this.hostgroups = response.data.return.all_hostgroups ?? [];
                    this.paging = response.data.return.paging ?? {
                        page: 1,
                        pageCount: 1,
                    };
                    //this.servicegroups =  servicegroups;
                })
                .catch(error => {
                    console.log(error)
                    useToast().error(this.$t('error'), {
                        timeout: 2000
                    });

                })
                .finally(() => {
                    loader.hide();
                    this.loading = false;
                });
        },

        allFilter: function(){
            this.resetFilter();
            this.getIndex();
        },
        resetFilter: function(){
            this.name = null;
            this.description = null;

            this.listFilter = {
                filter: {
                    id: [],
                    uuid: [],
                    name: '',
                    description: "",
                }
            };
        },
        refreshData: function(){
            this.resetFilter();
            this.getIndex();
        },
        goBack: function(){
            this.$router.back();
        }
    },
    watch: {
        name: debounce(function(newValue){
            if(newValue != null){
                this.listFilter.filter.name = newValue;
                this.getIndex();
            }
        }, 700),
        description: debounce(function(newValue){
            if(newValue != null){
                this.listFilter.filter.description = newValue;
                this.getIndex();
            }
        }, 700),
    }
}
</script>

<style scoped>

</style>
